// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React from 'react'
import './DeleteAllergiesPopUp.scss'
import { ConfirmationPopup } from '../../../components/confirmation-popup/confirmationpopup'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
const DeleteAlertPopUp = ({ setPopUpOpened, deleteAlertHandler }) => {
  return (
    // @ts-expect-error TS2739 -- MIGRATION: not approved, fix when encountered
    <ConfirmationPopup
      title='Delete alert'
      primaryBtnAction={deleteAlertHandler}
      primaryBtnText='Delete'
      popUpBoxStyle={{ marginTop: 200 }}
      secondaryBtnAction={() => {
        setPopUpOpened(null)
      }}
      secondaryBtnText='Cancel'
      msg='Are you sure you want to delete this alert?'
      closeAction={() => {
        setPopUpOpened(null)
      }}
    />
  )
}

export default DeleteAlertPopUp
